import { render, staticRenderFns } from "./twoColumnCard.vue?vue&type=template&id=0b1916d4&scoped=true"
import script from "./twoColumnCard.vue?vue&type=script&lang=js"
export * from "./twoColumnCard.vue?vue&type=script&lang=js"
import style0 from "./twoColumnCard.vue?vue&type=style&index=0&id=0b1916d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1916d4",
  null
  
)

export default component.exports